import { render, staticRenderFns } from "./processing-performance.vue?vue&type=template&id=ea45da4e&scoped=true&"
import script from "./processing-performance.vue?vue&type=script&lang=js&"
export * from "./processing-performance.vue?vue&type=script&lang=js&"
import style0 from "./processing-performance.vue?vue&type=style&index=0&id=ea45da4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea45da4e",
  null
  
)

export default component.exports